























type Coords = {
  accuracy: number;
  altitude: number | null;
  altitudeAccuracy: number | null;
  heading: number | null;
  latitude: number;
  longitude: number;
  speed: number | null;
};
type Position = { coords: Coords; timestamp: number };

import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MainView extends Vue {
  // @Prop() private msg!: string;
  hasGeo: boolean = false;
  position: Position | null = null;
  history: Position[] = [];
  coords: Coords | null = null;
  created() {
    if (navigator.geolocation) {
      this.hasGeo = true;
      console.log("beginning watch");
      navigator.geolocation.watchPosition(this.newPosition);
    } else {
      this.hasGeo = false;
    }
  }
  // get coords() {
  //   return this.position.coords.accuracy || "fart";
  // }

  newPosition(position: Position) {
    this.position = position;
    this.coords = position.coords;
    this.history.push(position);
    console.log("new position", position);
  }
  posToStr(pos: Position): string {
    const coords = pos.coords;
    return `accuracy: ${coords.accuracy} altitude: ${
      coords.altitude
    } altitudeAccuracy: ${coords.altitudeAccuracy} heading: ${
      coords.heading
    } latitude: ${coords.latitude} longitude: ${coords.longitude} speed: ${
      coords.speed
    } Time: ${new Date(pos.timestamp).toLocaleString()}`;
  }
}
